<template>
  <header class="header">
    <div class="px-4 py-3 flex items-center justify-between">
      <div class="flex items-center">
        <img src="/src/imgs/logo.png" alt="Lazily" class="h-12 w-auto mr-3" />
        <h1 class="text-xl font-bold header-title">Lazily Dashboard</h1>
        <span v-if="authStore.isAdmin" class="ml-2 px-2 py-1 text-xs admin-badge">
          Admin
        </span>
      </div>
      
      <div class="flex items-center gap-4">
        <nav class="hidden md:flex items-center gap-4">
          <router-link 
            to="/dashboard" 
            class="nav-link"
            :class="{ 'nav-link-active': $route.path === '/dashboard' }"
          >
            Dashboard
          </router-link>
          <router-link 
            to="/links" 
            class="nav-link"
            :class="{ 'nav-link-active': $route.path.startsWith('/links') }"
          >
            Links
          </router-link>
          <router-link 
            to="/analytics" 
            class="nav-link"
            :class="{ 'nav-link-active': $route.path === '/analytics' }"
          >
            Analytics
          </router-link>
          <router-link 
            v-if="authStore.isAdmin"
            to="/admin/tenants" 
            class="nav-link"
            :class="{ 'nav-link-active': $route.path === '/admin/tenants' }"
          >
            Tenants
          </router-link>
          <router-link 
            v-if="authStore.isAdmin"
            to="/keys" 
            class="nav-link"
            :class="{ 'nav-link-active': $route.path.startsWith('/keys') }"
          >
            Keys
          </router-link>
        </nav>
        
        <ThemeToggle />
        
        <button
          @click="handleLogout"
          class="btn btn-secondary btn-sm"
          :disabled="isLoggingOut"
        >
          <span v-if="isLoggingOut" class="spinner mr-2"></span>
          {{ isLoggingOut ? 'Signing out...' : 'Sign Out' }}
        </button>
      </div>
    </div>
  </header>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import { useAuthStore } from '@/stores/auth'
import ThemeToggle from './ThemeToggle.vue'

const router = useRouter()
const authStore = useAuthStore()

const isLoggingOut = ref(false)

const handleLogout = async () => {
  try {
    isLoggingOut.value = true
    authStore.logout()
    router.push('/login')
  } catch (error) {
    console.error('Logout error:', error)
  } finally {
    isLoggingOut.value = false
  }
}
</script>
